import { styled } from "@mui/material/styles";

const ButtonWrapper = styled("div")(() => ({
  position: "sticky",
  bottom: 0,
  width: "100%",
  padding: "16px",
  display: "block",
  marginTop: "auto",
}));

export default ButtonWrapper;